import Header from "./Header";
import About from './About';
import Nav from "./Nav";

function Homepage() {
    return(
        <Header />
    )
}

export default Homepage;